export const ListQueryKey = 'projectProjectRewards';
export const DetailQueryKey = 'projectProjectReward';
export const Urls = {
  selectUrl: '/projectreward/list',
  updateUrl: '/projectreward/update',
  deleteUrl: '/projectreward/delete',
  createUrl: '/projectreward/create',
  detailUrl: '/projectreward/info'
};